// Mobile-only slider for sections/image-columns.liquid. Each section instance
// owns its own Swiper, so several of these on one page don't interfere, and
// the custom element re-initialises itself when the theme editor re-renders it.
if (!customElements.get('image-columns-slider')) {
	class ImageColumnsSlider extends HTMLElement {
		connectedCallback() {
			this.container = this.querySelector('.swiper');
			this.pagination = this.querySelector('.image-columns__dots');
			this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
			this.mql = window.matchMedia('(max-width: 991px)');

			this.onBreakpoint = this.update.bind(this);
			this.onBlockSelect = this.handleBlockSelect.bind(this);
			this.mql.addEventListener('change', this.onBreakpoint);
			document.addEventListener('shopify:block:select', this.onBlockSelect);

			this.update();
		}

		disconnectedCallback() {
			this.mql.removeEventListener('change', this.onBreakpoint);
			document.removeEventListener('shopify:block:select', this.onBlockSelect);
			this.destroy();
		}

		update() {
			if (this.mql.matches && this.slides.length > 1) {
				this.init();
			} else {
				this.destroy();
			}
		}

		init() {
			if (this.swiper || typeof Swiper === 'undefined') return;
			this.swiper = new Swiper(this.container, {
				slidesPerView: 1,
				spaceBetween: 20,
				pagination: {
					el: this.pagination,
					clickable: true,
				},
			});
		}

		destroy() {
			if (!this.swiper) return;
			// cleanStyles drops the inline widths Swiper put on the slides, so the
			// desktop grid can lay them out again.
			this.swiper.destroy(true, true);
			this.swiper = null;
			this.pagination.innerHTML = '';
		}

		// Selecting a column in the theme editor brings it into view on mobile.
		handleBlockSelect(event) {
			if (!this.swiper || !this.contains(event.target)) return;
			const index = this.slides.indexOf(event.target.closest('.swiper-slide'));
			if (index > -1) this.swiper.slideTo(index);
		}
	}

	customElements.define('image-columns-slider', ImageColumnsSlider);
}
